import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, ProductsListsContext, AlertModal, ModalHelper, helper}  from "./../app.js"; 

export default class StudSelecter extends PureComponent 
{
    static contextType = ProductsListsContext;

    use_length = false;
    modal = null;

    constructor (props)
    {
        super(props);

        const studId = this.props.init_stud?.id;

        this.state = {
            studs: {},
            stud_conns: [],
            id: studId ?? '',
            length: this.props.init_stud?.use_length ?? this.props.init_stud?.length ?? '',
            loading: false,
            alert_message: ''
        };

        if (studId && this.useLengthFor(studId))
        {
            this.use_length = this.props.init_stud?.use_length ?? this.props.init_stud.length;
        }  

        this.modal = new ModalHelper(this);

        this.isActive = this.isActive.bind(this);
        this.selectStud = this.selectStud.bind(this);
        this.setLength = this.setLength.bind(this);
        this.checkLength = this.checkLength.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    get stud ()
    {
        const id = this.state.id;
        let stud = null;

        if (id && id in this.state.studs)
        {
            stud = this.state.studs[id];
        }
        return stud;
    }
    isActive ()
    {
        return this.props.carrier_type;
    }    
    loadStuds ()
    {
        if (this.isActive())    
        {
            const queryParams = {
                tray_articul: this.props.tray_articul,
                carrier_type: this.props.carrier_type,
                shore_type: this.props.shore_type, 
            };

            this.setState({loading: true});

            Server.instance
                    .query('get_studs', queryParams)
                    .then((recievedStuds) =>
                    {
                        helper.setStateWithRecievedItems(this, 'studs', recievedStuds, function (fields, product)
                        {
                            ({
                                isHairpin: product.is_hairpin = false
                            } = fields);

                            product.is_hairpin = !!product.is_hairpin;
                        });
                    })
                    .catch(() => this.setState({studs: {}, loading: false}));
        }        
    }  
    loadStudConnectors (id = '')
    {
        if (!id) id = this.state.id;

        const stud = this.state.studs?.[id];

        if (!helper.isNotObjectOrEmpty(stud))
        {
            const queryParams = {stud_articul: stud.articul};

            this.setState({loading: true});

            Server.instance
                    .query('get_stud_connectors', queryParams)
                    .then((recievedStudConnectors) =>
                    {
                        const studConnectors = helper.setStateWithRecievedItems(this, 'stud_conns', recievedStudConnectors); 

                        if (this.stud) 
                        {
                            this.props.on_select(this.state.length && this.state.length > this.stud.length ? studConnectors : [], 'stud_conns', false);
                        }                        
                    })
                    .catch(() => {
                        this.setState({stud_conns: [], loading: false});
                        this.props.on_select([], 'stud_conns', false);
                    });
        }
    }  
    selectStud (e)
    {
        const id = e.target.value,
            newStud = id ? helper.copyObject(this.state.studs[id]) : null;

        if (newStud)
        {
            const useLength = this.useLengthFor(id);

            this.setState({id, length: useLength ? newStud.length : ''});

            this.use_length = newStud.use_length = useLength ? newStud.length : false;
            this.props.on_select(newStud, 'stud');

            this.loadStudConnectors(id);
        } 
        else
        {
            this.use_length = false;
            this.setState({id: '', length: ''});

            this.props.on_select(null, 'stud');
            this.props.on_select([], 'stud_conns', false);
        }   
    }
    useLength () 
    {
        return this.useLengthFor(this.stud?.id);
    }
    useLengthFor(id)
    {
        //console.log(id, this.state, this.state.studs, this.state.studs?.[id]);

        return  id 
                && this.state.studs?.[id]?.length > 0 
                && (this.state.studs[id].name.indexOf('пилька') > 0
                    || this.state.studs[id].name.indexOf('ента перфорированная') > 0);
    }
    setLength (e) 
    {
        const stud = helper.copyObject(this.stud);

        if (stud && this.useLength())
        {
            const lengthValue = e.target.value;

            if ('' !== lengthValue)
            {
                const length = parseInt(lengthValue);

                if (isNaN(length) || (length && length < 0))
                {
                    this.setState({alert_message: `Некорректное значение длины стойки`});
                }
                else if (!length)
                {
                    this.setState({alert_message: `Не задана длина стойки`});
                }
                else 
                {
                    this.setState({length});

                    if (length >= 100)
                    {
                        this.use_length = stud.use_length = length;

                        this.props.on_select(stud, 'stud');
                        this.props.on_select(length > stud.length ? this.state.stud_conns : [], 'stud_conns', false);
                    }
                }
            }
            else
                this.setState({length: ''});
        }
    }
    checkLength (e)
    {
        if (this.stud && this.useLength() && e.target.value < 100)
        {
            const stud = helper.copyObject(this.stud);

            this.use_length = stud.use_length = stud.length;

            this.setState({
                alert_message: 'Значение длины стойки не может быть меньше 100', 
                length: stud.use_length 
            });

            this.props.on_select(stud, 'stud');
            this.props.on_select([], 'stud_conns', false);
        }        
    }    
    componentDidMount() 
    {
        this.loadStuds();
    }
    render () 
    {   
        //console.log(this.props.carrier_type); 
        const studsList = Object.keys(this.state.studs).map(id => 
                {
                    return <option key={id} value={id}>{'articul' == this.context ? this.state.studs[id].articul : this.state.studs[id].name}</option>;
                }),
            useLength = this.useLength(),
            disabled = !this.isActive();

        studsList.unshift(<option key="none" value="">Выберите стойку</option>);

        return  <><Form.Group as={Col} md={useLength ? 7 : 6}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Стойка:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectStud} onClick={this.modal.showProjectChangeWarning} value={this.state.id} disabled={disabled} as="select" custom>
                        {studsList}
                    </Form.Control>
                </Form.Group>
                {useLength
                ? <Form.Group as={Col} md={5}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Точная длина стойки:</Form.Label>
                    <Form.Control onChange={this.setLength} onBlur={this.checkLength} onClick={this.modal.showProjectChangeWarning} value={this.state.length} disabled={disabled} type="text" placeholder="Точная длина, мм" />
                </Form.Group>
                : ''}
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
    }
}
